<template>
  <div class="small-text">
    <!-- <p class="small-text--left">
      By logging into DoveMed you agree to our
      <a href="/about-us/terms-conditions/" target="_blank">Terms of Use </a>
      and
      <a href="/privacy-policy/" target="_blank">Privacy policy </a>
      We have changed the login system from username/password to email/password.
      If you do not remember your email, please send a mail to
      <a href="mailto:contact@dovemed.com">contact@dovemed.com</a> .
    </p> -->
    <p class="small-text__left">
      By continuing, you're confirming that you've read and agree to our
      <a href="/help-center/faq/mycircles-terms-of-use" target="_blank">Terms</a> and
      <a href="/help-center/faq/mycircles-privacy-policy" target="_blank">Privacy policy.</a>
    </p>
  </div>
</template>

<script>
export default {
  name: "privacy-policy",
};
</script>

<style lang="scss" scoped>
a:hover {
  color: #0075b4 !important;
}
.small-text {
  font-size: 12px;
  &__left {
    font-size: 14px;
    text-align: left;
    color: #647490;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/info/privacy-policy.vue